import { MessageDesignTokens } from '@primeuix/themes/types/message';

import { getRem } from '@customer-portal/shared/helpers/theme-utils';

export const messageOverride: MessageDesignTokens = {
  root: {
    borderWidth: getRem(0),
    borderRadius: getRem(10),
  },
  content: {
    padding: `${getRem(12)} ${getRem(18)}`,
  },
  text: {
    fontWeight: 'normal',
  },
};
